import React, {useState} from "react";
import "./style.scss";
import {Button} from "../../StyledComponents";
import {expIcon} from "../../../assets/icons/icons";
import {EXTENSION_URL} from "../../../constants";
import Platform from '../../../models/platforms-data';

const steps = {
  new: [
    {
      title: "Install the extension",
      description: (
        <>
          <div>
            Add it to your browser from the Chrome Web Store.
          </div>
          <Button variant="contained" color="primary" className='em-btn-install' mt={3} href={EXTENSION_URL}
                  target="_blank">
            <span>Download here</span>
            <img src={expIcon} className="feather-icon-in-button icon-ml"/>
          </Button>
        </>
      ),
    },
    {
      title: "Log in to your BackupLABS account",
      description: "Click the extension icon in your browser and sign in.",
    },
    {
      title: "Select the chat to back up",
      description: "Pick the conversation you want to safeguard and click backup.",
    },
    {
      title: "Your Trial will start automatically right after first backup",
      description: "",
    },
  ],
  installed: [
    {
      title: "Log in to your BackupLABS account",
      description: "Click the extension icon in your browser and sign in.",
    },
    {
      title: "Select the chat to back up",
      description: "Pick the conversation you want to safeguard and click backup.",
    },
    {
      title: "Your Trial will start automatically right after first backup",
      description: "",
    },
  ],
};

const Tab = ({label, active, onClick}) => {
  return (
    <button
      role="tab"
      aria-selected={active}
      onClick={onClick}
      className={active ? "em-tab-btn em-tab-btn-active" : "em-tab-btn"}
    >
      {label}
    </button>
  );
}

const Step = ({index, title, description}) => (
  <div className='em-step'>
    <div className='em-step-badge'>
      <span className='em-step-badge-text'>{index + 1}</span>
    </div>
    <div>
      <p className='em-step-title'>{title}</p>
      <p className='em-step-desc'>{description}</p>
    </div>
  </div>
);

const ExtensionModal = ({onClose, platform}) => {
  const [tab, setTab] = useState("new");

  return (
    <div id='extension-modal' className='em-overlay' onClick={onClose}>
      <div
        className='em-modal'
        aria-labelledby="modal-title"
        onClick={(e) => e.stopPropagation()}
        role="dialog" aria-modal="true"
      >
        <div className='em-header'>
          <div className='em-header-left'>
            <div className='em-icon-wrap'>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#3B82F6" strokeWidth="1.75"
                   strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
              </svg>
            </div>
            <div>
              <p id="modal-title" className='em-title'>Secure your {Platform[platform].title} history</p>
              <p className='em-subtitle'>
                Back up your conversations in seconds using our Google Chrome extension.
              </p>
            </div>
          </div>
          <button className='em-close-btn' onClick={onClose} aria-label="Close">
            ✕
          </button>
        </div>

        <div className='em-tab-bar' role="tablist">
          <Tab label="New to extension" active={tab === "new"} onClick={() => setTab("new")}/>
          <Tab label="Already installed" active={tab === "installed"} onClick={() => setTab("installed")}/>
        </div>

        <div className='em-panel' role="tabpanel">
          {steps[tab].map((step, i) => (
            <Step key={i} index={i} title={step.title} description={step.description}/>
          ))}
        </div>

        <div className='em-footer'>
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#F59E0B" strokeWidth="1.75"
               strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M9 18h6M10 22h4M12 2a7 7 0 0 1 7 7c0 2.5-1.5 4.5-3 6H8C6.5 13.5 5 11.5 5 9a7 7 0 0 1 7-7z"/>
          </svg>
          <p className='em-footer-text'>Open any chat in {Platform[platform].title} to start your first backup.</p>
        </div>

      </div>
    </div>
  );
};

export default ExtensionModal;
